import classNames from "classnames";
import React from "react";
import iconArrowDown from "../../../assets/icons/CaretDownYellow.svg";
import Check from "../../../assets/icons/check.svg";
const ActivityItem = ({
  onSelect = null,
  onStartIteraction,
  displayDetail = false,
  selected = false,
  item,
}) => {
  return (
    <div
      className={classNames(
        "flex flex-col gap-2 bg-DarkBlue-500 p-4 w-full rounded-md ",
        {
          "bg-opacity[0%]": displayDetail,
          "bg-opacity-[25%]": !displayDetail,
        }
      )}
    >
      <div className="flex justify-between w-full">
        <div className="flex items-center gap-3">
          {selected && <img src={Check} alt="check" />}
          <div>{item?.name}</div>
        </div>
        <div className="flex gap-4">
          {onSelect && (
            <div
              onClick={() => onStartIteraction(item)}
              className=" text-shaiaBlue underline flex items-center cursor-pointer"
            >
              Seleccionar
            </div>
          )}
          <div
            className="text-Yellow-500 flex gap-1 items-center cursor-pointer"
            onClick={() => onSelect ? onSelect(displayDetail ? null : item): null}
          >
            <div>{displayDetail ? "Ver menos" : "Ver más"}</div>
            <div>
              <img
                className={classNames(
                  "transition-transform transform rotate-0 ",
                  {
                    "rotate-180": displayDetail,
                  }
                )}
                src={iconArrowDown}
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      {displayDetail && <div className="w-full">{item?.description}</div>}
    </div>
  );
};

export default ActivityItem;
